<template>
	<div class="carousel-template">
		<header class="header">
			<h2 class="title">{{ template.title }}</h2>
			<div class="badges">
				<TeamingBadge v-if="template.isRecentlyUsed">
					{{ translate( "recentBadge" ) }}
				</TeamingBadge>
				<TeamingBadge v-else-if="template.isCustomTemplate">
					{{ translate( "customBadge" ) }}
				</TeamingBadge>
			</div>
		</header>
		<main class="body">
			<div class="topic-count">
				<FontAwesomeIcon :icon="[ `far`, `message-check` ]" />
				<span>{{ translate( "topicCount", { count: template.topics.length, } ) }}</span>
			</div>
			<p v-if="template.description">{{ template.description }}</p>
		</main>
		<footer class="footer">
			<div class="footer--left">
				<TeamingButton
					type="TERTIARY"
					size="SMALL"
					@click="$emit( `applyTemplate`, template )"
				>{{ translate( "applyButton" ) }}</TeamingButton>
				<TeamingButton
					type="QUATERNARY"
					size="SMALL"
					@click="$emit( `previewTemplate`, template )"
				>{{ translate( "previewButton" ) }}</TeamingButton>
			</div>
			<div class="footer--right">
				<TrashButton
					v-if="template.canDelete"
					size="SMALL"
					@click="$emit( `deleteTemplate`, template )"
				/>
			</div>
		</footer>
	</div>
</template>

<script>
import {
	TeamingBadge,
	TeamingButton,
	TrashButton
} from "@teaming/common-ui";

export default {
	name: "CarouselTemplate",
	emits: [
		"applyTemplate",
		"previewTemplate",
		"deleteTemplate",
	],
	components: {
		TeamingBadge,
		TeamingButton,
		TrashButton,
	},
	props: {
		template: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			const { name, } = this.$options;
			return this.$t( `common-team.components.${ name }.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
$titleColor: $color2-500;
$textColor: $color1-700;
$backgroundColor: $white;
$topicCountIconColor: $color1-500;

.carousel-template {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	padding: 1rem;
	background-color: $backgroundColor;
	border-radius: 0.5rem;

	&:hover {
		.footer--right {
			visibility: visible;
		}
	}
}

.carousel-template .header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	gap: 0.5rem;
}

.carousel-template .title {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $titleColor;
}

.carousel-template .badges {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-end;
}

.carousel-template .body {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	@include font-and-line-for(-1);
	font-weight: 450;
	color: $textColor;
	background-color: $backgroundColor;
}

.carousel-template .topic-count {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.2rem;
	font-weight: 600;

	svg {
		color: $topicCountIconColor;
	}
}

.carousel-template .footer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.carousel-template .footer--left {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
}

.carousel-template .footer--right {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 0.5rem;

	visibility: visible;

	@include for-size('md') {
		visibility: hidden;
	}
}
</style>
